import http from "../../http-common"

class CurrentJobsOpeningsService {
    getAllCurrentJobsOpenings(path: string) {
        return http.get(`/current-job-openings?path=${path}`)
    }  
}

export default new CurrentJobsOpeningsService();